<template>
  <div class="container container-login">
    <div class="wrap">
      <input type="radio" name="drawer" id="close-drawer">
      <label class="close" for="close-drawer" ref="closeDrawer">閉じる</label>
      <div class="login">
        <section class="detail">
          <h2>ログイン</h2>
          <p>ともつくネットへログイン</p>
          <p class="recommend">または
            <label class="signin" for="signin-drawer">アカウントを作成</label>
          </p>
          <c-validation-errors :errors-hash="errors"></c-validation-errors>
          <div class="form">
            <div class="group"></div>
            <div class="item">
              <input type="text" placeholder="メールアドレス" v-model="mail"><span class="focusborder"></span>
            </div>
            <div class="item">
              <input type="password" placeholder="パスワード" v-model="password" @change="clearMessage"><span class="focusborder"></span>
            </div>
            <div class="item submit">
              <input class="button-blue" type="submit" value="ログイン" @click="authenticate">
            </div>
            <p class="notice">アカウントを忘れてしまいましたか？<router-link to="/reissue-password" v-on:click="clickCloseDrawer">こちら</router-link>よりお手続きできます。</p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script setup>
import axios from "axios";
import Common from '../../js/common.js'
import Global from '../../js/constant.js'
import { onMounted, ref, reactive } from "vue"
import { useStore } from 'vuex'
import {useToast} from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import { useRouter } from 'vue-router'

// store取得
const $store = useStore();
const $toast = useToast();
const $router = useRouter();

// --- define state ---
const mail = ref("");
const password = ref("");
const closeDrawer = ref();
const errors = reactive({});

// action操作はdispatch
const save = () => $store.dispatch('save');

// mutation操作はcommit
const setAccount = (val) => $store.commit('setAccount', val);
const setAutoId = (val) => $store.commit('setAutoId', val);
const setHost = (val) => $store.commit('setHost', val);
const setLoginFlg = (flg) => $store.commit('setLoginFlg', flg);
const setMail = (val) => $store.commit('setMail', val);
const setClientErrors = (val) => $store.commit('setClientErrors', val);

// --- created ---
(() => {})();

// --- mounted ---
onMounted(() => {});

// --- methods ---
/**
 * 認証処理
 */
const authenticate = async () => {
  errors.value = {}

  if (!mail.value) {
    errors.value['mail'] = 'REQUIRED_CONSTRAINT_FAILED'
  }
  if (!password.value) {
    errors.value['password'] = 'REQUIRED_CONSTRAINT_FAILED'
  }
  if (Object.keys(errors.value).length > 0) {
    $toast.error("error", {position: 'bottom-left'})
    return
  }

  let account = await getAccount();

  if (account) {
    $toast.success(`Hi. ${account.nickname}.`,{ position: 'bottom-left' });

    await deleteAutoLogin(account);
    let autoId = await createAutoLogin(account);

    if (autoId) {
      setAutoId(autoId)
      setHost(Common.getUrlHost())
      setAccount(account)
      setMail(mail)
      setLoginFlg(true)
      save()
      $router.replace(`/myspace/${account.id}`)
    }
  }
};
const getAccount = async () => {
  let params = {};
  if (mail.value) params['mail'] = mail.value;
  if (password.value) params['password'] = password.value;

  return await axios.post(Global.url.api_accounts_authenticate, params)
  .then(res => {
    if (res.data.status == Global.api_status.success) {
      return res.data.account;
    }
    if (res.data.status == Global.api_status.validation_error) {
      errors.value = res.data.errors;
      return
    }
  })
  .catch(error=>{
    $toast.error('client error')
    setClientErrors({func:"login.vue::authenticate", params: params, errorMessage:error})
  });
}
/**
 * 前回の自動ログイン情報を削除
 */
const deleteAutoLogin = async (account) => {
  let params = { account_id : account.id }
  await axios.post(Global.url.api_auto_logins_delete, params)
  .then(res => {
    if (res.data.status != Global.api_status.success) {
      $toast.error('deleteAutoLogin 失敗')
    }       
  })
  .catch(error => {
      $toast.error('client error')
      setClientErrors({func:"common/header/login.vue::deleteAutoLogin", params: {accountId: account.id}, errorMessage:error})
  })
};

/**
 * 自動ログインIDを生成
 */
const createAutoLogin = async (account) => {
  let params = { account_id : account.id, session_id : $store.state.core.sessionId }
  return await axios.post(Global.url.api_auto_logins_create, params)
  .then(res => {
    if (res.data.status == Global.api_status.success) {
      return res.data.auto_login.auto_id
    }
    $toast.error('オートログイン処理失敗')
  })
  .catch(error=>{
    $toast.error('client error')
    setClientErrors({func:"common/header/login.vue::createAutoLogin", params: { account_id : account.id, session_id : this.$store.state.sessionId }, errorMessage:error})
  })
};

/**
 * 
 */
const clearMessage = () => {
  errors.value = {};
};

/**
 * リンククリック時にdrawerを閉じる
 */
const clickCloseDrawer = () => {
  closeDrawer.value.click()
}
</script>